import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { AppLocationState, trackPageView } from '@/services/analytics'

const useAnalyticsPageViews = () => {
    const location = useLocation()
    const isFirstRender = useRef(true)

    useEffect(() => {
        // Firebase already logs the initial page_view when Analytics starts.
        if (isFirstRender.current) {
            isFirstRender.current = false
            return
        }

        const source = (location.state as AppLocationState | null)?.navigationSource
        const frame = window.requestAnimationFrame(() => {
            trackPageView({
                path: location.pathname,
                title: document.title,
                source,
            })
        })

        return () => window.cancelAnimationFrame(frame)
    }, [location.key, location.pathname, location.state])
}

export default useAnalyticsPageViews
